<template>
  <div>
    <el-dialog
      :visible="visible"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="false"
      :append-to-body="true"
      custom-class="how-it-works-modal"
      @update:visible="updateVisible"
      @close="handleClose"
    >
      <div class="how-it-works">
        <h2>How it works</h2>
        <iframe
          id="vimeoPlayer"
          width="558"
          height="328"
          src="https://player.vimeo.com/video/1072560945?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
          title="Vixio Workspace"
        ></iframe>
        <div class="tooltip-assist">
          <a
            v-if="workspaceAccess"
            :href="createChecklistsUrl"
            class="button button__primary start-here button-link"
            target="_blank"
          >Get started</a>
          <el-button
            v-else
            @click="openDemoLink"
            class="button button__primary start-here button-link"
          >Book a demo with the team</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
// import Tooltip from "~/components/elements/Tooltip.vue";

export default {
  name: "ChecklistVideoEmbedModal",
  components: { /* Tooltip */ },
  model: {
    prop: "visible",
    event: "update:visible",
  },
  props: {
    visible: Boolean,
  },
  computed: {
    ...mapGetters("Auth", ["workspaceAccess"]),
    createChecklistsUrl() {
      return `${this.$config.workspaceFEURL}/add-checklist`;
    },
  },
  methods: {
    updateVisible(value) {
      this.$emit("update:visible", value);
    },
    handleClose() {
      this.pauseVideo(); // Pause video on modal close
      this.updateVisible(false);
    },
    pauseVideo() {
      const iframe = document.getElementById("vimeoPlayer");
      if (iframe) {
        // Sending a postMessage to the Vimeo player to pause the video
        iframe.contentWindow.postMessage(
          JSON.stringify({ method: "pause" }),
          "*"
        );
      }
    },
    openDemoLink() {
        window.open("https://www.vixio.com/vixio-workspace#apply-now", "_blank");
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/mixin";
@import "../../assets/styles/helpers/variables";

.how-it-works-modal {
  width: 606px;
}

.how-it-works {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  h2 {
    align-self: flex-start;
    line-height: 32px;
    font-size: 24px;
    font-weight: 700;
  }

  .tooltip-assist {
    position: relative;
    width: 100%;
  }

  .start-here[disabled] {
    &:hover {
      & + .tip {
        display: block;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .tooltip:hover {
    display: block;
    left: 50%;
    transform: translateX(-50%);
  }

  .button-link {
    text-decoration: none;
    display: inline-block;
    text-align: center;
  }

  .button {
    height: 44px;
    padding: 10px 18px;
    border: 1px solid $corporateBlue;
    font-weight: 400;
    line-height: 24px;
    font-size: 16px;
    letter-spacing: 0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px 0px #1018280d;
    margin: 0;

    &__primary {
      width: 100%;
      &, &:hover {
        background-color: $corporateBlue;
        color: $white;
        border: 1px solid #262053;
      }
    }

    &__secondary {
      background-color: white;
      color: $corporateBlue;
    }
  }
}
</style>
